import { DatePipe, DecimalPipe } from '@angular/common';
import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { MatCellDef } from '@angular/material';
import * as moment from 'moment';
import { PipeEnum } from 'src/app/shared/helpers/constants';
import { IColumnsDataTable } from '../../Entities/entities';
import { CheckNumberPipe } from '../../pipes/pipes';

@Directive({
  selector: '[appTableCellFormat]',
})
export class TableCellFormatDirective implements OnInit {
  @Input() column: IColumnsDataTable;
  @Input() element: MatCellDef;

  private el: HTMLTableDataCellElement;

  constructor(elRef: ElementRef, private renderer: Renderer2) {
    this.el = elRef.nativeElement;
  }

  ngOnInit() {
    if (!this.element) {
      return;
    }
    if (this.column.Icon === true) {
      this.renderer.addClass(this.el, 'mat-cell-right');
    } else if (this.column.Pipe !== undefined) {
      switch (this.column.Pipe) {
        case PipeEnum.thousandPipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.currencyCLPipe:
          try {
            this.renderer.addClass(this.el, 'mat-cell-right');
          } catch (error) {
            this.el.innerHTML = '0';
          }
          break;
        case PipeEnum.UFPipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.decimalPipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.datePipe:
          this.renderer.addClass(
            this.el,
            this.column.IconAlign ? this.column.IconAlign : 'mat-cell-center'
          );
          break;
        case PipeEnum.checkNumberPipe:
          if (!isNaN(parseFloat(this.element[this.column.ColumnDef]))) {
            this.renderer.addClass(this.el, 'mat-cell-right');
          } else {
            this.renderer.addClass(this.el, 'mat-cell-left');
          }
          break;
        case PipeEnum.percentagePipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.purePercentagePipe:
          this.renderer.addClass(this.el, 'mat-cell-right');
          break;
        case PipeEnum.dateNombreMesPipe:
          this.renderer.addClass(this.el, 'mat-cell-left');
          break;
        case PipeEnum.dateNombreMesPipe2:
          this.renderer.addClass(this.el, 'mat-cell-left');
          break;
        case PipeEnum.edadPipe:
          this.renderer.addClass(this.el, 'mat-cell-left');
          break;
        default:
          this.renderer.addClass(this.el, 'mat-cell-left');
          const col2 = ['DOLARES', 'UNIDAD DE FOMENTO', 'PESOS', 'EURO'];
          this.el.innerHTML = this.element[this.column.ColumnDef];
          const aux = JSON.stringify(this.element).indexOf('Rentabilidad');
          if (
            col2.indexOf(this.element[this.column.ColumnDef]) === -1 &&
            aux > -1
          ) {
            const child = this.renderer.createElement('img') as HTMLElement;
            child.setAttribute('src', '../../../assets/icons/download.svg');
            this.el.appendChild(child);
          }
          break;
      }
    }
  }
}
